import { reducer as toastrReducer } from 'react-redux-toastr';

import { reducer as basketReducer } from './basket/basket.slice';
import { reducer as cardReducer } from './card/card.slice';
import { reducer as catalogReducer } from './catalog/catalog.slice';
import { reducer as favoriteReducer } from './favorite/favorite.slice';
import { reducer as layoutReducer } from './layout/layout.slice';
import { reducer as mainReducer } from './main/main.slice';
import { reducer as publicationReducer } from './publication/publication.slice';
import { reducer as reviewReducer } from './review/review.slice';
import { reducer as searchReducer } from './search/search.slice';
import { reducer as userReducer } from './user/user.slice';

export const reducers = {
  user: userReducer,
  card: cardReducer,
  basket: basketReducer,
  catalog: catalogReducer,
  favorite: favoriteReducer,
  layout: layoutReducer,
  main: mainReducer,
  review: reviewReducer,
  publication: publicationReducer,
  search: searchReducer,
  toastr: toastrReducer,
};
